import type { DefaultAttributeValue } from '@source-components-react/types';
import { MOUNT_NAME_ATTRIBUTE, MOUNT_PROPS_ATTRIBUTE } from './mount-attributes';

/**
 * A fresh mount has no name and no props. Seeding either would invent a
 * registration the host does not have, so both stay empty until the author
 * fills them in.
 */
export const defaultAttributeValues: DefaultAttributeValue[] = [
  {
    name: MOUNT_NAME_ATTRIBUTE,
    defaultValues: {},
  },
  {
    name: MOUNT_PROPS_ATTRIBUTE,
    defaultValues: {},
  },
];
